import { useQuery } from '@tanstack/react-query';
import { presaleSheetApi } from '../api/presaleSheetApi';

export const usePresaleSheetPdf = (warrantyUuid: string | null, showPrice = true, bannerColor?: string, headerImage?: string) => {
  return useQuery({
    queryKey: ['presale-sheet-pdf', warrantyUuid, showPrice, bannerColor, headerImage],
    queryFn: () => {
      if (!warrantyUuid) throw new Error('warrantyUuid is required');
      return presaleSheetApi.generatePdf(warrantyUuid, showPrice, bannerColor, headerImage);
    },
    enabled: !!warrantyUuid,
    staleTime: 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
